import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  fetchFiltersDropdownValues,
  fetchOrderListReturn,
  fetchOrderListByFilterReturn,
  updateExportToExcelPathReturn,
  resetReturnOrder,
  resetOrderListErrorReturn,
} from "./redux/returnsListSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  createFilterPayload,
  lastMileCountryDataTransform,
  getErrorStatusMsg,
  getErrorStatusFieldReadMore,
} from "../mocks/returnsList/response.transforms";
import { AppState } from "../config/redux/reducers";
import { useStyles } from "./ReturnsList.styles";
import AppConstants from "../constants";
import { Grid } from "@material-ui/core";
import GridWrapper from "../common/GridWrapperV2";
import ConsignmentDetails from "./ConsignmentDetails";
import PrintShippingLabel from "../SharedComponent/components/PrintShippingLabel";
import moment from "moment";
import Loader from "../common/Loader";
import CustomStatusBar from "../common/CustomStatusBar";
import { userLogout } from "../Login/redux/loginSlice";
import _ from "lodash";
import {
  RowData,
  SortModel,
  RowParams,
  SelectionChangeParams,
} from "../common/GridWrapperV2/DataTable";
import ExportInitiatedDialog from "ExportIntiaiedDialog";

const ReturnsList = (props: any) => {
  const dispatch = useDispatch();
  const componentClasses = useStyles();

  const {
    data,
    filtersDropdowns,
    tableLoading,
    loader,
    error,
    errorCode,
    repushReturnMsg,
    repushReturnFlag,
    loading,
    exportInitiated,
    reportId,
  } = useSelector((state: AppState) => state.returnsList);
  const { countryCode, hubRecordListWithCodeAndName } = useSelector((state: AppState) => state.common);

  const snackbarType = useRef(AppConstants.SNACKBAR.TYPES.SUCCESS);
  const snackbarMessage = useRef("");

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [listToShow, setListToShow] = useState([]);
  const [consignmentData, setConsignmentData] = useState({});
  const [
    openConsignmentDetailsPopup,
    setOpenConsignmentDetailsPopup,
  ] = useState(false);
  const [
    openPrintShippingLabelPopup,
    setOpenPrintShippingLabelPopup,
  ] = useState(false);
  const [selectedConsignments, setSelectedConsignments] = useState(
    [] as RowData[]
  );

  const [tableWrapperData, setTableWrapperData] = useState({
    ...AppConstants.RETURN_CONSTANTS.TABLE_WRAPPER_DATA,
    defaultFiltersObj: {
      ...AppConstants.RETURN_CONSTANTS.TABLE_WRAPPER_DATA.defaultFiltersObj,
      dateRange: {
        startDate: moment().format(AppConstants.DATE_FORMAT),
        endDate: moment().format(AppConstants.DATE_FORMAT),
      },
      hub: AppConstants.RETURN_CONSTANTS.TABLE_WRAPPER_DATA.defaultFiltersObj
              .hub,
    },
    HeaderData: AppConstants.RETURN_CONSTANTS.TABLE_WRAPPER_DATA.HeaderData.map(
      (header: any) => {
        const newHeader = { ...header };
        if (newHeader.field === "statusErrors") {
          newHeader.renderCell = (params: any) => (
            <Grid className={componentClasses.statusHeader}>
              <Grid item>{getErrorStatusMsg(params.value)}</Grid>
              <Grid item className="statusMsgMore">
                {getErrorStatusFieldReadMore(params.value)}
              </Grid>
            </Grid>
          );
        }
        return newHeader;
      }
    ),
  });

  const [openExportInitiatedInfo, setOpenExportInitiatedInfo] = useState(false);
  const handleDialogClose = () => {
    setOpenExportInitiatedInfo(false);
  };

  useEffect(() => {
    if (exportInitiated) {
      setOpenExportInitiatedInfo(true);
    }
  }, [exportInitiated]);

  const fetchAllFilters = () => {
    dispatch(fetchFiltersDropdownValues());
  };

  const handleHeaderButtonsDisableState = useCallback(() => {
    const headerButtons = tableWrapperData.headerButtons.map((btn: any) => {
      switch (btn.name) {
        case "print":
          btn.disabled = !selectedConsignments.length;
          break;
        case "excel":
          btn.disabled = listToShow.length
            ? data.totalElements >
              AppConstants.CONSIGNMENT_CONSTANTS.DISABLE_EXPORT_EXCEL
              ? true
              : false
            : true;
          break;
        default:
          break;
      }
      return btn;
    });
    setTableWrapperData({ ...tableWrapperData, headerButtons: headerButtons });
  }, [tableWrapperData, selectedConsignments, listToShow, data]);

  const handleLoadMoreDisableState = useCallback(() => {
    const loadMoreState = tableWrapperData.loadMore;
    loadMoreState.disabled = data.totalPages
      ? data.pageNumber + 1 >= data.totalPages
      : true;
    setTableWrapperData({ ...tableWrapperData, loadMore: loadMoreState });
  }, [tableWrapperData, data]);

  const filterCallback = (filters: any, isLoadMore?: boolean) => {
    if (filters) {
      const requestContinuationToken = data.continuationToken;
      const payloadFilters = _.cloneDeep(filters);
      payloadFilters[AppConstants.COUNTRY_CODE] =
        sessionStorage.getItem(AppConstants.COUNTRY_CODE) ||
        countryCode;
      const payload = createFilterPayload(payloadFilters, data, isLoadMore);
      if (payload.page) {
        payload.requestContinuationToken = requestContinuationToken;
      }
      dispatch(
        fetchOrderListByFilterReturn({
          filters: payload,
        })
      );
    }
  };

  const fetchOrder = (
    searchBy: string,
    value: string,
    filters: any,
    isLoadMore: boolean
  ) => {
    if (searchBy && value) {
      let page = 0;
      if (isLoadMore) {
        page = data.pageNumber + 1 <= data.totalPages ? data.pageNumber + 1 : 0;
      }
      const requestContinuationToken = data.continuationToken;
      const payload = { page: page } as any;
      if (payload.page) {
        payload.requestContinuationToken = requestContinuationToken;
      }
      const activeFilters = _.cloneDeep(filters);
      activeFilters.searchAttribute = {
        key: searchBy,
        value: value,
      };
      filterCallback(activeFilters);
    }
  };

  const handleExcelExport = (filters: any) => {
    if (filters) {
      const payloadFilters = _.cloneDeep(filters);
      payloadFilters[AppConstants.COUNTRY_CODE] =
        sessionStorage.getItem(AppConstants.COUNTRY_CODE) ||
        countryCode;
      const payload = createFilterPayload(payloadFilters, data, false, true);
      dispatch(updateExportToExcelPathReturn({ payload: payload }));
    }
  };

  const openSnackbarPopup = (msg: string, type: string) => {
    snackbarMessage.current = msg;
    snackbarType.current = type;
    setOpenSnackbar(true);
  };

  const searchFilterHandler = (
    data: { [key: string]: string },
    filters: any,
    isLoadMore: boolean
  ) => {
    const searchKeys = Object.keys(data);
    if (searchKeys.length > 0) {
      const searchKey = searchKeys[0];
      data[searchKey] = _.trim(data[searchKey]);
      if (
        data[searchKey] &&
        data[searchKey].length >= AppConstants.SEARCH_BOX_LIMIT
      ) {
        fetchOrder(searchKey, data[searchKey], filters, isLoadMore);
      } else {
        openSnackbarPopup(
          AppConstants.SEARCH_TEXT_LIMIT,
          AppConstants.SNACKBAR.TYPES.ERROR
        );
      }
    }
  };

  const handleRowClick = (params: RowParams) => {
    if (data && params.data) {
      const selectedRow = params.data;
      const selectedConsignment = data.content.filter(
        (item: any) => item.rmaNumber === selectedRow.returnId
      );
      const consignment = selectedConsignment.length
        ? { ...selectedConsignment[0], tableRecord: selectedRow }
        : { tableRecord: selectedRow };
      setConsignmentData(consignment);
      setOpenConsignmentDetailsPopup(true);
    }
  };

  const updateSelectedRows = useCallback((params: SelectionChangeParams) => {
    setSelectedConsignments(params.rows);
  }, []);

  const handleHeaderButtonClick = useCallback(
    (btnObj: any) => {
      if (btnObj && btnObj.type) {
        switch (btnObj.type) {
          case "print":
            setOpenPrintShippingLabelPopup(true);
            break;
          case "excel":
            handleExcelExport(btnObj.params);
            break;
          default:
            break;
        }
      }
    },
    [handleExcelExport]
  );

  const closeConsignmentDetailsPopup = () => {
    setOpenConsignmentDetailsPopup(false);
  };

  const closePrintShippingLabelPopup = () => {
    setOpenPrintShippingLabelPopup(false);
  };


  const handleSessionExpired = useCallback(() => {
    if (
      errorCode ===
      AppConstants.RETURN_CONSTANTS.RESPONSE_CONSTANTS.ERROR_CODES
        .SESSION_TIMEOUT
    ) {
      dispatch(userLogout());
    }
    if (snackbarType.current === AppConstants.SNACKBAR.TYPES.ERROR) {
      dispatch(resetOrderListErrorReturn());
    }
  }, [dispatch, errorCode]);

  const handleSnackbarClose = useCallback(() => {
    setOpenSnackbar(false);
    handleSessionExpired();
  }, [handleSessionExpired]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setOpenSnackbar(false);
      handleSessionExpired();
    }, AppConstants.SNACKBAR.AUTO_HIDE_TIMEOUT);
    return () => clearTimeout(timer);
  });

  useEffect(() => {
    if (error) {
      openSnackbarPopup(error, AppConstants.SNACKBAR.TYPES.ERROR);
    }
  }, [error]);

  useEffect(() => {
    if (repushReturnFlag) {
      setOpenConsignmentDetailsPopup(false);
      openSnackbarPopup(repushReturnMsg, AppConstants.SNACKBAR.TYPES.SUCCESS);
      dispatch(resetReturnOrder());
    }
  }, [dispatch, repushReturnFlag]);

  useEffect(() => {
    setListToShow(lastMileCountryDataTransform(data) as any);
    handleLoadMoreDisableState();
  }, [data]);

  useEffect(() => {
    handleHeaderButtonsDisableState();
  }, [listToShow, selectedConsignments]);

  useEffect(() => {
    const filterFormData = tableWrapperData.FilterFormData.map((filter: any) => {
      if (filter.fieldName === "hub") {
        filter.items =
          hubRecordListWithCodeAndName[
            sessionStorage.getItem(AppConstants.COUNTRY_CODE) || countryCode
          ] || [];
      }
      if (filter.fieldName === "deliveryStatus") {
        filter.items =
          (countryCode && filtersDropdowns.statusList[countryCode]) ||
          filtersDropdowns.statusList[countryCode] ||
          [];
      }
      if (filter.fieldName === "proposition") {
        filter.items =
          (countryCode &&
            filtersDropdowns.delPropositionList[countryCode]) ||
          filtersDropdowns.delPropositionList[countryCode] ||
          [];
      }
      return filter;
    });
    setTableWrapperData({
      ...tableWrapperData,
      FilterFormData: filterFormData,
    });
  }, [countryCode, hubRecordListWithCodeAndName]);

  useEffect(() => {
    if (tableWrapperData && tableWrapperData.FilterFormData) {
      const filterFormData = tableWrapperData.FilterFormData.map(
        (filter: any) => {
          if (filter.fieldName === "hub") {
            filter.items = hubRecordListWithCodeAndName[
              sessionStorage.getItem(AppConstants.COUNTRY_CODE) ||
                countryCode ||
                AppConstants.COUNTRY_OBJ.value
            ] || [];
          }
          if (filter.fieldName === "deliveryStatus") {
            filter.items =
              filtersDropdowns.statusList[
                sessionStorage.getItem(AppConstants.COUNTRY_CODE) ||
                  countryCode ||
                  AppConstants.COUNTRY_OBJ.value
              ] || [];
          }
          if (filter.fieldName === "proposition") {
            filter.items =
              filtersDropdowns.delPropositionList[
                sessionStorage.getItem(AppConstants.COUNTRY_CODE) ||
                  countryCode ||
                  AppConstants.COUNTRY_OBJ.value
              ] || [];
          }
          return filter;
        }
      );
      setTableWrapperData({
        ...tableWrapperData,
        FilterFormData: filterFormData,
      });
    }
  }, [filtersDropdowns, hubRecordListWithCodeAndName, countryCode]);

  return (
    <div className={componentClasses.root}>
      {(loading || loader) && <Loader></Loader>}
      {openSnackbar && (
        <CustomStatusBar
          open={openSnackbar}
          handleClose={handleSnackbarClose}
          message={snackbarMessage.current}
          type={snackbarType.current}
        />
      )}
      {openPrintShippingLabelPopup && (
        <PrintShippingLabel
          open={openPrintShippingLabelPopup}
          selectedRows={selectedConsignments}
          closePopup={closePrintShippingLabelPopup}
        ></PrintShippingLabel>
      )}
      {openConsignmentDetailsPopup && (
        <ConsignmentDetails
          open={openConsignmentDetailsPopup}
          consignment={consignmentData}
          closePopup={closeConsignmentDetailsPopup}
        ></ConsignmentDetails>
      )}
      <Grid className={componentClasses.pageTitle}>Returns</Grid>
      <GridWrapper
        headerData={tableWrapperData.HeaderData}
        rowData={listToShow}
        loading={loading ? undefined : tableLoading}
        searchTypes={tableWrapperData.SEARCH_TYPES}
        filterForm={tableWrapperData.FilterFormData}
        defaultFilter={tableWrapperData.defaultFiltersObj}
        headerButtons={tableWrapperData.headerButtons}
        title={tableWrapperData.title}
        sortModel={tableWrapperData.sortModel as SortModel}
        loadMore={{
          ...tableWrapperData.loadMore,
          rowCount: data.totalElements || 0,
        }}
        onRowClick={handleRowClick}
        onSelectionChange={updateSelectedRows}
        headerBtnClick={handleHeaderButtonClick}
        searchCallback={searchFilterHandler}
        filterGrid={filterCallback}
        fetchAllFilters={fetchAllFilters}
      />
      {openExportInitiatedInfo && (
        <ExportInitiatedDialog
          openExportInitiatedInfo={openExportInitiatedInfo}
          handleDialogClose={handleDialogClose}
          reportId={reportId}
        />
      )}
    </div>
  );
};

export default ReturnsList;
